import LocalStorageKey from "../../common/enums/LocalStorageKey";

class LMPAuthUtils {
    // LMP 인증 후 복귀 주소.
    // 빌드 시 리전/환경에 맞게 REACT_APP_REDIRECT_URI 로 주입됨 (setup.sh 참고).
    // 미주입 시 로컬 개발용 기본값 사용.
    static getRedirectUri() {
        return process.env.REACT_APP_REDIRECT_URI || "https://laundry-admin.dev.amuz.kr/redirect";
    }

    // LMP 로그인(sign_in) 페이지로 이동할 전체 URL 생성.
    // 인증 요청과 이후 토큰 교환의 redirect_uri 는 반드시 동일해야 하므로 getRedirectUri() 로 통일.
    static getLoginUrl({ serverCountry }) {
        // 언어: 사용자가 LanguageSelector 에서 고른 UI 언어를 반영. 없으면 국가별 기본 언어로 폴백.
        // 국가: 선택한 serverCountry. → language=`{선택언어}-{선택국가}` (예: 한국어+태국 → ko-TH)
        const language = localStorage.getItem(LocalStorageKey.language) || this.getTermLanguage({ countryCode: serverCountry });
        const redirectUri = encodeURIComponent(this.getRedirectUri());
        return (
            `https://qt-${serverCountry.toLowerCase()}.m.lgaccount.com/membership-b2b-webapp/login/sign_in` +
            `?client_id=a4209c397c0f4999945ed7f4b6e86578` +
            `&biz_code=B01004C037.01` +
            `&country=${serverCountry}` +
            `&language=${language}-${serverCountry}` +
            `&state=login` +
            `&show_login_type=LGE` +
            `&redirect_uri=${redirectUri}`
        );
    }

    static getLMPServer({ countryCode }) {
        switch (countryCode) {
            case "KR": // 한국
            case "VN": // 베트남
            case "ID": // 인도네시아
            case "MY": // 말레이시아
            case "SG": // 싱가포르
            case "IN": // 인도
            case "TH": // 태국
            case "JP": // 일본
            case "NP": // 네팔
            case "HK": // 홍콩
            case "CN": // 중국
            case "TW": // 대만
            case "AU": // 오스트레일리아
            case "KH": // 캄보디아
            case "LK": // 스리랑카
            case "NZ": // 뉴질랜드
            case "PH": // 필리핀
            default:
                return "kr";
        }
    }

    static getTermLanguage({ countryCode }) {
        switch (countryCode) {
            case "KR": // 한국
                return "ko";
            case "VN": // 베트남
                return "vi";
            case "ID": // 인도네시아
                return "id";
            case "MY": // 말레이시아
                return "ms";
            case "SG": // 싱가포르
                return "sg";
            case "TH": // 태국
                return "th";
            case "JP": // 일본
                return "ja";
            case "NP": // 네팔
                return "ne";
            case "HK": // 홍콩
            case "CN": // 중국
                return "zh";
            case "IN": // 인도
            case "TW": // 대만
            case "AU": // 오스트레일리아
            case "KH": // 캄보디아
            case "LK": // 스리랑카
            case "NZ": // 뉴질랜드
            case "PH": // 필리핀
            default:
                return "en";
        }
    }

    static getTermData({ countryCode }) {
        const lang = this.getTermLanguage({ countryCode: countryCode });
        switch (countryCode) {
            case "KR": // 한국
                return `TOU_LAUNDRYINST:20200702001_${countryCode}:${lang},PRV_LAUNDRYINST:20200702001_${countryCode}:${lang}`;
            case "IN": // 인도
                return `TOU_LAUNDRYINST:20230519001_${countryCode}:${lang},PRV_LAUNDRYINST:20230519001_${countryCode}:${lang}`;
            case "TH": // 태국
                // 원래 th 여야하는데 LMP 서버에서 잘못 넣은듯?
                return `TOU_LAUNDRYINST:20201007001_${countryCode}:sg,PRV_LAUNDRYINST:20201007001_${countryCode}:${lang}`;
            case "JP": // 일본
                return `TOU_LAUNDRYINST:20230519001_${countryCode}:${lang},PRV_LAUNDRYINST:20230519001_${countryCode}:${lang}`;
            case "AU": // 오스트레일리아
                return `TOU_LAUNDRYINST:20201007001_${countryCode}:${lang},PRV_LAUNDRYINST:20201008001_${countryCode}:${lang}`;
            case "PH": // 필리핀
                return `TOU_LAUNDRYINST:20201007001_${countryCode}:${lang},PRV_LAUNDRYINST:20220822001_${countryCode}:${lang}`;
            case "LK": // 스리랑카
            case "NZ": // 뉴질랜드
            case "VN": // 베트남
            case "ID": // 인도네시아
            case "MY": // 말레이시아
            case "CN": // 중국
            case "TW": // 대만
            case "NP": // 네팔
            case "HK": // 홍콩
            case "SG": // 싱가포르
            case "KH": // 캄보디아
            default:
                return `TOU_LAUNDRYINST:20201007001_${countryCode}:${lang},PRV_LAUNDRYINST:20201007001_${countryCode}:${lang}`;
        }
    }
}

export default LMPAuthUtils;
